// extracted by mini-css-extract-plugin
module.exports = {"noResults":"no-results_noResults__b8Kcf","illustration":"no-results_illustration__9FzzE","description":"no-results_description__RHpn0"};